import {
    Container,
    TextInput,
    PasswordInput,
    Button,
    Title,
    Paper,
    Checkbox,
    Stack,
} from '@mantine/core'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { useState } from 'react'
import axios from 'axios'
import { toast } from 'react-toastify'
import config from "../config";

export function LoginPage() {
    const { login } = useAuth()
    const navigate = useNavigate()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [rememberMe, setRememberMe] = useState(false)

    const handleLogin = async () => {
        try {
            const response = await axios.post(`${config.BASE_URL}/auth/login`, {
                email,
                password,
            })

            const { accessToken, refreshToken } = response.data

            if (rememberMe) {
                localStorage.setItem('accessToken', accessToken)
                localStorage.setItem('refreshToken', refreshToken)
            } else {
                sessionStorage.setItem('accessToken', accessToken)
                sessionStorage.setItem('refreshToken', refreshToken)
            }

            login()
            navigate('/admin')
        } catch (error) {
            toast.error('Login failed. Please check your credentials.')
            console.error('Login error:', error)
        }
    }

    return (
        <Container size={420} mt={100}>
            <Title  mb="lg" order={2}>
                Admin Login
            </Title>

            <Paper withBorder shadow="md" p="xl" radius="md">
                <Stack>
                    <TextInput
                        label="Email"
                        placeholder="admin@admin.com"
                        required
                        value={email}
                        onChange={(e) => setEmail(e.currentTarget.value)}
                    />

                    <PasswordInput
                        label="Password"
                        placeholder="••••••"
                        required
                        value={password}
                        onChange={(e) => setPassword(e.currentTarget.value)}
                    />

                    <Checkbox
                        label="Remember me"
                        checked={rememberMe}
                        onChange={(event) => setRememberMe(event.currentTarget.checked)}
                    />

                    <Button fullWidth mt="md" onClick={handleLogin}>
                        Login
                    </Button>
                </Stack>
            </Paper>
        </Container>
    )
}
